var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    [_vm.$c('layout')]: true,
    [_vm.$c(`layout-${_vm.direction || _vm.hasSidebar() ? 'row' : 'column'}`)]: true,
    [_vm.$c('layout-has-sidebar')]: _vm.hasSidebar()
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }